import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="max-w-md text-center">
        <p className="text-6xl font-bold text-ink-900">404</p>
        <h1 className="mt-4 text-xl font-semibold text-ink-900">
          Page not found
        </h1>
        <p className="mt-2 text-sm text-ink-500">
          The page you're looking for doesn't exist or was moved.
        </p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/" className="btn-primary no-underline">
            Go home
          </Link>
          <Link to="/app" className="btn-secondary no-underline">
            Open app
          </Link>
        </div>
      </div>
    </div>
  );
}
